import React, { useState } from "react";
import ReportsTable from "./components/ReportsTable";
import Navbar from "../../components/Navbar";
import Pagination from "../../components/Pagination";

export default function Reports(props) {
  return (
    <div className="min-h-full bg-gray-50">
      <div className="pb-32">
        <Navbar props={props} />

        {/* Заголовок */}
        <header className="py-12">
          <div className="mx-auto container max-w-screen-2xl px-4">
            <h1 className="text-3xl font-semibold tracking-tight text-black">
              Отчеты
            </h1>
          </div>
        </header>
      </div>

      {/* Основной контент */}
      <main className="-mt-32">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
          <div className="overflow-hidden rounded-lg bg-white shadow-lg">
            <ReportsTable reports={props.periods} forms={props.forms} />
          </div>
          <Pagination
            currentPage={props.current_page}
            totalPages={props.total_pages}
            basePath="/reports"
          />
        </div>
      </main>
    </div>
  );
}
